import { render, staticRenderFns } from "./AlarmManage.vue?vue&type=template&id=83acb0ce&scoped=true&"
import script from "./AlarmManage.vue?vue&type=script&lang=js&"
export * from "./AlarmManage.vue?vue&type=script&lang=js&"
import style0 from "./AlarmManage.vue?vue&type=style&index=0&id=83acb0ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83acb0ce",
  null
  
)

export default component.exports